export default "__VITE_ASSET__B3387odz__"